export const FETCH_REPORTS_LIST = "FETCH_REPORTS_LIST";
export const GENERATE_REPORT = "GENERATE_REPORT";
export const RESET_GENERATE_REPORT = "RESET_GENERATE_REPORT";
export const FETCH_PARAMETER_LIST = "FETCH_PARAMETER_LIST";
export const FETCH_BATCH_LIST_FOR_REPORT = "FETCH_BATCH_LIST_FOR_REPORT";
// export const FETCH_REPORT_FILE = "FETCH_REPORT_FILE";
export const CLEAR_REPORT_FILE_API_STATUS = "CLEAR_REPORT_FILE_API_STATUS";
export const FETCH_REPORT_DETAILS_FOR_EDIT = "FETCH_REPORT_DETAILS_FOR_EDIT";
export const CLEAR_BATCH_DATA_ON_PRODUCT_CHANGE = "CLEAR_BATCH_DATA_ON_PRODUCT_CHANGE";